import React from 'react';
import { I18n } from 'react-redux-i18n';
import { TextField, List, ListItemText, ListItem, Tooltip, IconButton, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { deleteIcon } from '../../../app/utils/icons';
import globalStyles from '../../../styles';


const changeItem = (item, event, props) => {

  const componentIndex = props.lstComponents.map(obj => obj.componentId).indexOf(event.target.value);
  item.componentId = event.target.value;
  props.onChangeItem();

};

const changeName = (item, event, props) => {

  item.name = event.target.value;
  props.onChangeItem();

};


export default props => (
  <div>

    <List
      component="div"
      style={{ paddingLeft: '5%' }}
    >
      {props.items.map((item, i) => (
        <div>
          <ListItem>
            <TextField
              id="stepName"
              label="Nome do Campo"
              value={item.name}
              style={{ width: '50%' }}
              onChange={event => changeName(item, event, props)}
              margin="normal"
              autoComplete={false}
              onKeyPress={(event) => {


              }}
            />
            <FormControl >
              <Select
                value={item.componentId}
                onChange={event => changeItem(item, event, props)}
                fullWidth
                style={{ marginLeft: 15, marginTop: '1.5rem' }}
              >
                <MenuItem value={-1} > <em>Selecione</em> </MenuItem>
                {props.lstComponents.map(component => (
                  <MenuItem value={component.componentId} key={component.componentId}>
                    {component.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Tooltip title={I18n.t('button.delete')}>
              <IconButton aria-label="Delete" onClick={() => props.onRemoveDynamicField(item, i, props.items)}>
                {deleteIcon}
              </IconButton>
            </Tooltip>
          </ListItem>
        </div>
      ))
      }
    </List>
  </div>
);




// WEBPACK FOOTER //
// ./src/components/tracker/Flow/WorkflowDynamicFields.js